import './index.css';

import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';

import { TOOLTIP_CONTAINER_CLASSNAME } from '@fragment/ui/src/components/Tooltip/OverflowTooltip';
import { POSTHOG_MASK_CLASS } from '@fragment/ui/src/constants';

import { App } from './App';
import { reportWebVitals } from './reportWebVitals';
import { FragmentEnv } from './utils/env';
import { beforeSendToPostHog } from './utils/posthog';

// NOTE: This is a workaround for SyntaxHighlighter not working reliably in the
// EmbedCodeDialog component. It seems to have the effect of warming some
// sort of internal cache that avoids a race condition within
// SyntaxHighlighter.
// See: https://github.com/react-syntax-highlighter/react-syntax-highlighter/issues/513
createRoot(document.createElement('div')).render(
  // eslint-disable-next-line react/no-children-prop
  <SyntaxHighlighter language="" children="" />
);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <PostHogProvider
    apiKey={FragmentEnv.posthog.apiKey}
    options={{
      api_host: `https://${FragmentEnv.posthog.domain}`,
      enable_recording_console_log: false,
      before_send: beforeSendToPostHog,
      session_recording: {
        // Inputs are masked by PostHog default; set it explicitly so the
        // behavior is version-controlled rather than reliant on the default.
        maskAllInputs: true,
        // Non-input text is unmasked by default; mask only elements tagged
        // with POSTHOG_MASK_CLASS (ledger data in tables, summaries, and
        // detail panes). Masking cascades to descendants. Tooltips render
        // their content in a portal outside the tagged subtree, so also mask
        // the shared tooltip container to redact overflow/hover text.
        maskTextSelector: `.${POSTHOG_MASK_CLASS}, .${TOOLTIP_CONTAINER_CLASSNAME}`,
      },
    }}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </PostHogProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// @ts-expect-error "we import restify-errors which assumes process.env exists"
window.process = {
  env: {},
};
